/** Nombre maximum de colonnes ouvertes simultanément dans le deck */
export const MAX_COLUMNS = 50

/** Clé localStorage des infos utilisateur (LDAP), partagée entre le store user et le plugin api (logout) */
export const USER_INFO_STORAGE_KEY = 'user-info'

/** Intervalle de rafraîchissement en ms des dates relatives affichées (card, viewer) */
export const RELATIVE_TIME_REFRESH_INTERVAL = 10_000

/** Délai avant nouvelle tentative de refresh du token après un échec réseau/serveur transitoire (ms) */
export const REFRESH_RETRY_DELAY = 30_000

/** Timeout du refresh de token (ms), pour les réseaux mobiles dégradés */
export const REFRESH_TIMEOUT = 15_000

/** Nombre d'échecs de refresh consécutifs à partir duquel on log un warning */
export const REFRESH_FAILURE_WARNING_THRESHOLD = 5
